module.exports = __webpack_public_path__ + "static/media/geburtsvorbereitung.5379d842.jpg";